<template>
  <IconListItem icon="prepaid-participating" :label="$t('myorders.listitem.participating.label')">
    {{
      $t('myorders.listitem.participating.value', {
        participated: prepaidOptions?.participatedDraws,
        total: prepaidOptions?.totalDraws,
      })
    }}
  </IconListItem>
</template>

<script lang="ts" setup>
import type { SubscriptionMultipleLines } from '#api/shared/@types/generated/backend/graphql-schema-types'

import IconListItem from '~/components/IconList/IconListItem.vue'

type MyOrdersListItemPlayProps = {
  prepaidOptions: SubscriptionMultipleLines['prepaidOptions']
}

defineProps<MyOrdersListItemPlayProps>()
</script>
